const isObject = globeState => typeof globeState === 'object';

export const globeStates = {
  INTRO: 'introState',
  LOCATION: 'selectLocationState',
  SHOCK: 'globalShockState',
  QUESTION: 'questionaireState',
  QUESTION_AFTER_CHART: 'afterState',
  BEFORE_RESULT: 'beforeResultState',
  RESULT: 'resultState',
  BROWSE_COMPANIES: 'browseCompanyState',
  USERS_JOINED: 'usersJoined',
};

const isValidStateId = stateId => Object.values(globeStates).includes(stateId);

const stateNotValid = state => {
  // eslint-disable-next-line no-console
  console.log(`State ${state} is not valid`);
  return false;
};

export function isValidState(state) {
  if (isObject(state)) {
    if (state.current === undefined || state.target === undefined) {
      // eslint-disable-next-line no-console
      console.log('current and target properties have to bet set');
      return false;
    }
    if (!isValidStateId(state.current) || !isValidState(state.target)) {
      stateNotValid(state);
    }
  } else if (!isValidStateId(state)) {
    stateNotValid(state);
  }

  return true;
}
